import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useLoad, act } from "@/lib/hooks";
import { api } from "@/lib/api";
import { Section, Field, StatusBadge } from "@/components/common";

export function AgyinAllowance({ tenantId }) {
  const [u, reload] = useLoad(`/platform/tenants/${tenantId}/agyin-usage`);
  const [v, setV] = useState("");
  useEffect(() => { if (u) setV(u.override ?? ""); }, [u]);
  if (!u) return null;
  const save = async (allowance) => { if (await act(() => api.put(`/platform/tenants/${tenantId}/agyin-usage`, { allowance }), "Allowance saved")) reload(); };
  return (
    <Section title="Agyin Pro usage" testId="agyin-allowance-section" action={<StatusBadge tone={u.pro ? "success" : "neutral"} label={u.pro ? "ai_pro on" : "no ai_pro"} className="!normal-case" />}>
      <div className="space-y-3 p-5 text-sm">
        <div data-testid="agyin-usage-summary"><b>{u.used}</b> of {u.allowance} Pro invocations used in {u.month} ({u.pct}%){u.level && <StatusBadge tone={u.level === "limit" ? "danger" : "warning"} label={u.level === "limit" ? "limit reached" : "80% used"} className="ml-2" />}</div>
        <Field label="Monthly allowance override (blank = default 500)"><Input type="number" min="1" data-testid="agyin-allowance-input" value={v} onChange={(e) => setV(e.target.value)} placeholder="500" /></Field>
        <div className="flex gap-2"><Button data-testid="agyin-allowance-save" onClick={() => save(v === "" ? null : Number(v))} className="bg-[#13294B] hover:bg-[#1c3a66]">Save</Button>
          {u.override != null && <Button variant="outline" data-testid="agyin-allowance-reset" onClick={() => save(null)}>Use default</Button>}</div>
        <p className="text-xs text-slate-500">Soft limit only. Workspaces see a notice at 80% and 100% but are never blocked. Counters reset on the first day of each month.</p>
      </div>
    </Section>);
}
